"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchResultPage = void 0;
var _fetching = require("@ori/fetching");
var _reactRouterDom = require("react-router-dom");
var _SearchHeader = require("../../components/SearchHeader/SearchHeader");
var _SearchResults = require("../../components/SearchResults/SearchResults");
var _contexts = require("../../contexts");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchResultPage = ()=>{
    const { loading, searchQuestions, search } = (0, _contexts.useSearchResultContext)();
    const searchPath = (0, _reactRouterDom.useLocation)().search;
    const queryParts = searchPath.match("query=([^\\/?&#]*)");
    const query = queryParts ? queryParts[1] : null;
    (0, _fetching.useSWR)([
        query,
        search,
        searchQuestions.length
    ], async ()=>{
        if (query && !searchQuestions.length) {
            const decodedQuery = window.decodeURI(query);
            search(decodedQuery);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchHeader.SearchHeader, {}),
            loading && searchQuestions.length < 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchResults.SearchResults, {})
        ]
    });
};
exports.SearchResultPage = SearchResultPage;
